module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/vi/4-31b694ff1fc13ff99daf64b0553656f9.jpg";